import { connect } from 'react-redux'
import { IStore } from '../../reducers'
import { isUserAuthorized } from '../../reducers/userAccount/selectors/credentials'
import { IIsAuthorized } from './Protected'

const mapStateToProps = () => {
  const isAuth = isUserAuthorized

  return (state: IStore): IIsAuthorized => ({
    isAuthorized: isAuth(state),
  })
}

export default connect(mapStateToProps())
